import { useState, useEffect } from 'react';
import useSWR, { mutate } from 'swr';

import { SESSION_TIMEOUT, FOCUS_THROTTLE_INTERVAL } from '@/config/appSettings';

import * as API from '@/lib/organizationApi';
import { IResponseError } from '@/lib/apiBase';
import { IRepository } from '@/types';
import { IEvaluation, TEvaluationStatus, fetchEvaluation } from '@/lib/evaluationsApi';

// const revalidate = (orgname: string) => {
//   const key = ['organization', orgname];
//   // console.log('revalidate > key', key);
//   mutate(key, undefined, { revalidate: true });
// };

const useEvaluation = ({
  repository,
  evaluationId,
  evaluation: initialEvaluation,
}: {
  repository: IRepository;
  evaluationId: string;
  evaluation?: IEvaluation;
}) => {
  const [evaluation, setEvaluation] = useState<IEvaluation | undefined>(initialEvaluation);
  const [status, setStatus] = useState<TEvaluationStatus>(evaluation?.status || 'unknown');
  const [error, setError] = useState<IResponseError | undefined>();

  const fetchKey = ['evaluation', evaluationId];

  const {
    data,
    error: requestError,
    isLoading,
    isValidating,
    mutate,
  } = useSWR(fetchKey, () => fetchEvaluation({ repository, evaluationId }), {
    fallback: {
      evaluation: initialEvaluation,
      status: 'success',
      isLoading: false,
      statusCode: 200,
      status_message: 'OK',
    },
    keepPreviousData: true,
    revalidateOnFocus: false,
    revalidateOnMount: !initialEvaluation,
    revalidateOnReconnect: false,
    focusThrottleInterval: FOCUS_THROTTLE_INTERVAL,
  });

  const revalidate = () => {
    mutate();
  };

  useEffect(() => {
    if (data) {
      setEvaluation(data?.evaluation);
      setStatus(data?.evaluation?.status || 'unknown');
      setError(data?.error as IResponseError);
    }
  }, [data]);

  return { evaluation, status, error, revalidate };
};

export default useEvaluation;
